<template>
  <div class="page-content znjcTable" :style="defaultHeight">
    <div class="startTitle">微心理</div>
    <el-row class="filter">
      <el-col :span="24">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="类型">
            <el-select v-model="formInline.type" placeholder="" style="width: 270px;">
              <el-option :label="item.name" :value="item.name+'__'+item.diseaseType" v-for="(item,index) in optLists" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间">
            <el-select v-model="formInline.dateType" placeholder="请选择" style="width: 130px;" @change="dateSelectChange()">
              <el-option label="请选择" value=""></el-option>
              <el-option label="本月" value="0"></el-option>
              <el-option label="最近三个月" value="1"></el-option>
              <el-option label="最近六个月" value="2"></el-option>
              <el-option label="最近一年" value="3"></el-option>
              <el-option label="自定义" value="4"></el-option>
            </el-select>
            <el-date-picker style="width: 260px;" type="daterange" v-model="formInline.time" :readonly="isDateShow" range-separator="-" start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围">
            </el-date-picker>
          </el-form-item>
          <el-form-item style="float: right">
            <el-button type="success" @click="searchClick()" style="background-color: #13C76Bl;" class="dmh-btn sec-btn">搜索</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table v-loading="loading" :data="tableData" border style="width: 100%">
          <!--  <el-table-column
            prop="addTime"
            label="诊测时间"
            width="180"
            :formatter="set_addTime"
          >
          </el-table-column> -->
          <el-table-column prop="participle" label="诊测时间">
          </el-table-column>
          <el-table-column prop="diseaseContents" label="疾病说明">
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="120">
            <template slot-scope="scope">
              <el-button @click.native.prevent="itemSeefxbgRow(scope.row)" type="text" size="small">
                查看分析报告
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-button type="success" @click="open=true" class="dmh-colbtn" style="width:160px;float: right;margin-top: 30px;">马上体验</el-button>
      </el-col>
      <el-col :span="24">
        <pagination style="float: right;" class="paginationBox" v-show="total>0" :total="total" :page.sync="currentPage" :limit.sync="pageSize" @pagination="getList" layout="prev, pager, next" />
      </el-col>
    </el-row>
    <!-- <el-dialog :visible.sync="open" width="644px" :show-close="false" style="line-height:1px;">
      <div class="codewrap">
        <img src="@/assets/images/app_coder.png">
        <p>扫码下载吾征AI健康 APP</p>
        <p></p>
      </div>
      <div class="codewrap">
        <img src="@/assets/images/weixin_coder.png">
         <p>扫码关注吾征AI公众号</p>
        <p></p>
      </div>

      <div id="alertwarp">
        <div id="alertmask"></div>
        <div id="alertwx">
        </div>
      </div>
    </el-dialog> -->
    <el-dialog :visible.sync="open" width="1000px" :show-close="false" style="line-height:1px; text-align:center; margin-top:0; padding-top:0;">
      <img class='codewrapImg' src='@/assets/images/app_coder2.png' />
      <div class='codewrapdiv'>为了您更快捷全面的获取健康数据及更便捷的查看健康数据报告</div>
      <div class='codewrapdiv'>请您使用吾征AI健康APP或微信公众号体验健康服务</div>
      <div class='codewrapdiv2'>（扫描下方二维码下载安装APP或关注吾征AI微信公众号）</div>
      <div style='margin-bottom: 30px;'>
        <div class="codewrap">
          <img src="@/assets/images/app_coder.png">
          <p>吾征AI健康APP</p>
          <p>扫码下载</p>
        </div>
        <div class="codewrap">
          <img src="@/assets/images/weixin_coder.png">
          <p>吾征AI公众号</p>
          <p>扫码关注</p>
        </div>
      </div>
      <!-- 关注公众号 -->
      <div id="alertwarp">
        <div id="alertmask"></div>
        <div id="alertwx">
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import '@/assets/css/backcommon.css'
import { AIDiagnosisType, diagnosisList } from "@/api/dataReport";
export default {
  name: "xinliQuestion",
  data() {
    return {
      open: false,
      loading: true,
      optLists: '',
      defaultHeight: {
        height: ""
      },
      buttonIndex: -1,
      firstPage: 1,
      prevPage: "",
      nextPage: "",
      total: 0,
      lastPage: "", //1000/10
      currentPage: 1,
      pageSize: 10,
      tableData: [],
      formInline: {
        type: '',
        dateType: "",
        time: ['', ''],

      },
      isDateShow: true,
      params: ""
    }
  },
  components: {},
  mounted() {
    //页面创建时执行一次getHeight进行赋值，顺道绑定resize事件
    // window.addEventListener("resize", this.getHeight);
    // this.getHeight();
    // this.getList();
    this.AIDiagnosisType();

  },
  methods: {
    //定义方法，获取高度减去头尾
    getHeight() {
      this.defaultHeight.height = window.innerHeight - 105 + "px";
    },
    //日期格式化
    set_addTime(row, column) {
      console.log(row, column);
      var d = new Date(row.addTime);
      return d.getFullYear() + '-' + this.zeroFn((d.getMonth() + 1)) + '-' + this.zeroFn(d.getDate())
      //d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();

    },
    //诊病类别
    AIDiagnosisType() {
      var ths = this;
      AIDiagnosisType({ isDiagnosis: 7 }).then(res => {
        console.log(res);
        ths.optLists = res.data.rows;
        ths.formInline.type = ths.optLists[0].name + "__" + ths.optLists[0].diseaseType;
        ths.getList();
      });
    },
    toqsfxPage() {
      this.$router.push("/personCenter/znjcIndex/znjcQsfx")
    },
    //查看分析报告
    itemSeefxbgRow(row) {
      console.log(row);
      this.open = true;
    },
    zeroFn(num) {
      return num < 10 ? "0" + num : num
    },

    //监听时间
    dateSelectChange() {
      var dateType = this.formInline.dateType;
      /* if(parseInt(dateType)===4){
           this.isDateShow=true;
       }else{
           this.isDateShow=false;
       }*/
      console.log(dateType);
      if (parseInt(dateType) === 0) {
        var date = new Date();
        this.isDateShow = true;
        const start = date.getFullYear() + "-" + this.zeroFn(date.getMonth() + 1) + "-01";
        const end = date.getFullYear() + "-" + this.zeroFn(date.getMonth() + 1) + "-" + new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
        this.formInline.time = [start, end];

      } else if (parseInt(dateType) === 1) {
        this.isDateShow = true;
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
        this.formInline.time = [start, end];

      } else if (parseInt(dateType) === 2) {
        this.isDateShow = true;
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
        this.formInline.time = [start, end];

      } else if (parseInt(dateType) === 3) {
        this.isDateShow = true;
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 360);
        this.formInline.time = [start, end];

      } else if (parseInt(dateType) === 4) {
        this.isDateShow = false;
        this.formInline.time = ['', ''];
      } else if (dateType === "") {
        this.isDateShow = true;
        this.formInline.time = ['', ''];
      }
    },
    paramsFn() {
      if (this.formInline.time[0] !== "" && this.formInline.time[1] !== "") {
        const start = new Date(this.formInline.time[0]);
        const end = new Date(this.formInline.time[1]);
        this.formInline.time[0] = start.getFullYear() + '-' + this.zeroFn((start.getMonth() + 1)) + '-' + this.zeroFn(start.getDate());
        this.formInline.time[1] = end.getFullYear() + '-' + this.zeroFn((end.getMonth() + 1)) + '-' + this.zeroFn(end.getDate());
      }
      console.log(this.formInline.type);
      var type = this.formInline.type.split("__");
      console.log(type);
      this.params = {
        "reportType": 7,
        "isDiagnosis": type[1],
        "startTime": this.formInline.time[0],
        "endTime": this.formInline.time[1],
        "pageSize": this.pageSize, //每页数量
        "pageNum": this.currentPage
      };
    },
    //点击搜索
    searchClick() {
      this.resetPage();
      this.getList();
    },
    //重置页数
    resetPage() {
      this.currentPage = 1;
    },
    //请求数据
    getList() {
      this.loading = true;
      var ths = this;
      this.paramsFn();
      diagnosisList(this.params).then(res => {
        if (res.data.code === 200) {
          if (res.data.rows == null) {
            ths.total = res.data.total;
            ths.tableData = [];
            ths.loading = false;
          } else {
            ths.tableData = res.data.rows;
            ths.total = res.data.total;
            ths.lastPage = res.data.total / 10;
            ths.loading = false;
          }

        }
      })
    }


  },
}

</script>
<style>
.el-dialog__body {
  padding-top: 0;
}

.codewrapImg {

  width: 128px;
  height: 128px;
  margin-bottom: 50px;
}

.codewrapdiv {
  height: 15px;
  color: #000000;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
}

.codewrapdiv2 {
  height: 15px;
  color: #666;
  font-size: 15px;
  font-weight: 400;
  margin-bottom: 55px;
}



.memberCenter .el-dialog__header {
  border: none;
}

.codewrap {
  display: inline-block;
  width: 100px;
  margin-right: 70px;
  margin-left: 70px;
  text-align: center;
}

.codewrap img {
  padding-bottom: 10px;
  margin-top: 40px;
}

.codewrap p {
  width: 100%;
  height: 22px;
  line-height: 22px;
  margin-bottom: 20px;
}

.znjcTable .lineH {
  /*line-height: 60px;*/
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ededed;
}

.znjcTable .filter {
  padding-left: 10px;
  padding-top: 22px;
  padding-bottom: 1px;
}

.znjcTable .textR {
  text-align: right;
}

.znjc_tit img {
  position: relative;
  /*top: 10px;*/
  left: 10px;
  width: 40px;
  height: 40px;
  display: inline-block;
}

.znjc_tit span {
  margin-left: 15px;
  display: inline-block;
  font-size: 28px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
}

.seeqsfxBtn {
  margin-right: 20px;
  background-color: #59677f;
  border-radius: 3px;
}

.paginationBox {
  padding-right: 20px;
}

.paginationBox .el-pagination {
  display: inline-block !important;
}

/*.paginationBox .el-button {
  padding: 7px 8px;
  position: relative;
  top: 1px;
}*/
.sec-btn {
  background: #14c86c;
  border-color: #14c86c;
}

.sec-btn:hover {
  background: #14c86c;
  border-color: #14c86c;
  opacity: 0.9;
}

</style>



// WEBPACK FOOTER //
// src/views/personCenter/xinliQuestion.vue